// The composer is its own file, fetched on the first Communicate
// press. `load` is replaceable so a spec can stand in for the network.
const defaultLoad = () => import("./ComposerModal.tsx")

export const composerFile = {
  defaultLoad,
  load: defaultLoad
}

let loadsInFlight = 0

export const isOffline = () =>
  typeof navigator !== "undefined" && navigator.onLine === false

export const loadComposer = async () => {
  loadsInFlight += 1
  try {
    return await composerFile.load()
  } finally {
    loadsInFlight -= 1
  }
}

// Vite reports a failed load as `vite:preloadError` before the import
// rejects, and the app answers that event with a reload. While the composer
// is loading and the browser is offline, a reload can only fail and would
// throw away whatever the user has open, so the event stops here and the
// rejection reaches the composer's own offline notice. Online, it passes:
// a file a deploy replaced still reloads the app as before.
if (typeof window !== "undefined") {
  window.addEventListener(
    "vite:preloadError",
    (event) => {
      if (loadsInFlight > 0 && isOffline()) event.stopImmediatePropagation()
    },
    { capture: true }
  )
}
